export default [
  // 用户点击不再展示弹窗时调用
  {
    name: "BlockPopup",
    url: "/popup/block",
    method: "POST",
    mock: false,
  },
  // 获取当前用户可见的弹窗列表（前端用户）
  {
    name: "GetUserPopupList",
    url: "/popup/list",
    method: "GET",
    mock: false,
  },
  {
    name: "ListDelivery",
    url: "/delivery/list",
    method: "GET",
    mock: false,
  },
];
